import React from "react";

import RenderOrientations, {
    RenderOrientationFlow,
} from "../../types/enums/RenderOrientation";
import { Side, Size } from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

import "./InputGroup.scss";

interface InputGroupProps {
    header?: string; 

    className?: string;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    position?: Side;

    bondTop?: boolean;
    direction?: RenderOrientationFlow;

    children?: React.ReactNode;
}

interface InputGroupState {}

class InputGroup extends React.Component<InputGroupProps, InputGroupState> {
    render(): React.ReactNode {
        let classNames = this.props.className
            ? `input-group ${this.props.className}`
            : "input-group";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        switch (this.props.direction) {
            case RenderOrientations.RightLeft:
                classNames += " flex-row-reverse";
                break;
            default:
                classNames += " flex-row";
                break;
        }

        return <div className={classNames}>
            {this.props.header && <div className="input-group-header">{this.props.header}</div>}
            {this.props.children}
        </div>;
    }
}

export default InputGroup;
